"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.threeDStatuses = exports.PaymentStatus = exports.ButtonSizeOption = exports.FlowType = exports.Intent = exports.CheckoutStateEnum = exports.IntegrationTypeEnum = exports.PaymentMethodType = void 0;
var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType["card"] = "card";
    PaymentMethodType["paypal"] = "paypal";
    PaymentMethodType["apple_pay"] = "apple_pay";
    PaymentMethodType["google_pay"] = "google_pay";
})(PaymentMethodType || (exports.PaymentMethodType = PaymentMethodType = {}));
var IntegrationTypeEnum;
(function (IntegrationTypeEnum) {
    IntegrationTypeEnum["Primer"] = "primer";
    IntegrationTypeEnum["Braintree"] = "braintree";
})(IntegrationTypeEnum || (exports.IntegrationTypeEnum = IntegrationTypeEnum = {}));
var CheckoutStateEnum;
(function (CheckoutStateEnum) {
    CheckoutStateEnum["processing"] = "processing";
    CheckoutStateEnum["completed"] = "completed";
    CheckoutStateEnum["failed"] = "failed";
    CheckoutStateEnum["cancelled"] = "cancelled";
})(CheckoutStateEnum || (exports.CheckoutStateEnum = CheckoutStateEnum = {}));
var Intent;
(function (Intent) {
    // eslint-disable-next-line prettier/prettier
    /**
     * Submits the transaction for authorization but not settlement.
     */
    Intent["Authorize"] = "authorize";
    /**
     * Validates the transaction without an authorization (i.e. without holding funds).
     * Useful for authorizing and capturing funds up to 90 days after the order has been placed.
     * Only available for Checkout flow.
     */
    Intent["Order"] = "order";
    /**
     * Payment will be immediately submitted for settlement upon creating a transaction.
     * `sale` can be used as an alias for this value.
     */
    Intent["Capture"] = "capture";
})(Intent || (exports.Intent = Intent = {}));
var FlowType;
(function (FlowType) {
    // eslint-disable-next-line prettier/prettier
    /**
     * Used to store the payment method for future use, ie subscriptions
     */
    FlowType["Vault"] = "vault";
    /**
     * Used for one-time checkout
     */
    FlowType["Checkout"] = "checkout";
})(FlowType || (exports.FlowType = FlowType = {}));
var ButtonSizeOption;
(function (ButtonSizeOption) {
    // eslint-disable-next-line prettier/prettier
    /**
     * Recommended. Default.
     * 150 pixels by 25 pixels
     */
    ButtonSizeOption["Small"] = "small";
    /**
     * 250 pixels by 35 pixels
     */
    ButtonSizeOption["Medium"] = "medium";
    /**
     * 350 pixels by 40 pixels
     */
    ButtonSizeOption["Large"] = "large";
    /**
     * Dynamic
     * Matches the width of the container element, height is decided dynamically based on width.
     * Minimum width is 150px, maximum width is 500px.
     */
    ButtonSizeOption["Responsive"] = "responsive";
})(ButtonSizeOption || (exports.ButtonSizeOption = ButtonSizeOption = {}));
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["success"] = "success";
    PaymentStatus["error"] = "error";
})(PaymentStatus || (exports.PaymentStatus = PaymentStatus = {}));
exports.threeDStatuses = [
    'authenticate_attempt_successful',
    'authenticate_successful',
];
//# sourceMappingURL=type.js.map